import React from 'react';
import { Link } from 'react-router-dom';
import withRouter from '../../components/Common/withRouter';
import SeoDetails from '../../seo/SeoDetails';
import useArtist from './hooks/useArtist';
import userImageDefault from '../../assets/images/default/user-image.png';
const Artists = (props) => {
    const {
        artists,
        totalArtist,
        cityName,
        loadMore
    } = useArtist(props.router);

    return (
        <>
            <SeoDetails
                title="Discover Top Event Artists & Performers | Artist Directory – MePass"
                description="Explore our complete list of artists and performers on MePass. View bios, event history, and profiles of musicians, comedians, speakers, and creators – all in one place."
                ogImage=""
                keywords=""
            />


            <section className="bg-white py-16">
                <div className="container">
                    <div className="mb-6">
                        <h1 className="text-base md:text-3xl font-bold text-[#212121] capitalize line-clamp-1">
                            Artists
                        </h1>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 md:gap-4 lg:gap-6">
                        {artists.map((singleArtist) => (
                            <div className="flex flex-col gap-3" key={singleArtist.id} to={`/artist/${singleArtist.slug}`}>
                                <div className="relative">
                                    <Link to={'/artist/' + singleArtist.slug}>
                                        <img
                                            src={singleArtist.image ? singleArtist.image : userImageDefault}
                                            alt=""
                                            className="w-full rounded-xl aspect-[1/1] object-cover"
                                        />
                                    </Link>
                                </div>
                                <div>
                                    <h4 className="text-[#101010] text-[14px] md:text-md font-semibold">
                                        {singleArtist.name}
                                    </h4>
                                    <div className="flex items-center mt-[2px]">
                                        <p className="text-[#737373] text-[12px] md:text-base font-medium flex-1">
                                            {singleArtist.category_of_artist
                                                ? singleArtist.category_of_artist
                                                : ''}
                                        </p>
                                        {singleArtist.rating > 0 ? (
                                            <div className="border border-[#CB2129] py-[2px] px-[4px] inline-block rounded-full text-nowrap flex-none">
                                                <Link to={'/artist/' + singleArtist.slug}>
                                                    <p className="text-[#101010] text-[12px] md:text-[14px] font-semibold">
                                                        <i className="fa-solid fa-star mr-1 text-[#F0BA0E] text-sm"></i>
                                                        <span className="font-semibold">{singleArtist.rating}</span>
                                                    </p>
                                                </Link>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    {artists.length === 0 && (
                        <div className="text-center text-black">
                            <h2 className="text-2xl font-body font-normal text-center">
                                No Artist Found
                            </h2>
                        </div>
                    )}
                    {artists.length < totalArtist && (
                        <div className="text-center text-black mt-10">
                            <button
                                onClick={loadMore}
                                className="border border-red-600 text-red-600 py-2 px-4 rounded-lg"
                            >
                                Load more
                            </button>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
};

export default withRouter(Artists);
